import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2790108b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-collection" }
const _hoisted_2 = {
  key: 0,
  class: "no-image"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "preview-item-image" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import AspectRatio from '../aspect-ratio/AspectRatio.vue';
import Image from './Image.vue';
import { nextTick, ref, watch } from 'vue';

interface Props {
  images: number[],
  ratio?: [number, number],
  currentImageIndex?: number,
  enableReorder?: boolean,
}
interface Emits {
  (e: 'update:currentImageIndex', index: number): void;
  (e: 'reorder', reorder: { from: number, to: number }): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCollectionPreview',
  props: {
    images: null,
    ratio: { default: () => [1, 1] },
    currentImageIndex: { default: 0 },
    enableReorder: { type: Boolean }
  },
  emits: ["update:currentImageIndex", "reorder"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:currentImageIndex', index: number): void;
  (e: 'reorder', reorder: { from: number, to: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { images: number[], ratio: [number, number], currentImageIndex: number, enableReorder?: boolean }





const index = ref<number>(props.currentImageIndex);
const previewRef = ref<HTMLElement>();
const previewHover = ref<boolean>(false);

watch(() => props.currentImageIndex, (value) => {
  if (index.value !== value) {
    index.value = value;
  }
});
watch(index, () => {
  nextTick(() => {
    const previewEl = previewRef.value;
    if (previewEl) {
      const currentEl = previewEl.children[index.value];

      const previewRect = previewEl.getBoundingClientRect();
      const currentRect = currentEl.getBoundingClientRect();

      previewEl.scrollTo(previewEl.scrollLeft + (currentRect.left - previewRect.left - previewRect.width/2 + currentRect.width/2), 0);
    }
  })
}, {
  immediate: true,
})

function moveLeft() {
  if (index.value > 0) {
    index.value -= 1;
    emit('update:currentImageIndex', index.value);
  }
}
function moveRight() {
  if (index.value < props.images.length - 1) {
    index.value += 1;
    emit('update:currentImageIndex', index.value);
  }
}
function setIndex(i: number) {
  if (index.value !== i) {
    index.value = i;
    emit('update:currentImageIndex', index.value);
  }
}

function reorderLeft(index: number) {
  emit('reorder', {
    from: index,
    to: index - 1,
  });
}
function reorderRight(index: number) {
  emit('reorder', {
    from: index,
    to: index + 1,
  });
}

// TODO: add scrolling and reordering feature with drag&drop for preview list

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AspectRatio, {
      ratio: __props.ratio,
      class: "image-container"
    }, {
      default: _withCtx(() => [
        (__props.images.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('components.image-upload.no-image')), 1))
          : _createCommentVNode("", true),
        (__props.images[index.value])
          ? (_openBlock(), _createBlock(Image, {
              key: 1,
              class: "w-full",
              id: __props.images[index.value]
            }, null, 8, ["id"]))
          : _createCommentVNode("", true),
        (__props.images.length > 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("button", {
                class: "arrow-button arrow-button-left",
                disabled: index.value === 0,
                onClick: moveLeft
              }, [
                _createVNode(_component_FontAwesomeIcon, { icon: "chevron-left" })
              ], 8, _hoisted_3),
              _createElementVNode("button", {
                class: "arrow-button arrow-button-right",
                disabled: index.value === __props.images.length - 1,
                onClick: moveRight
              }, [
                _createVNode(_component_FontAwesomeIcon, { icon: "chevron-right" })
              ], 8, _hoisted_4)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["ratio"]),
    (__props.images.length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "previewRef",
          ref: previewRef,
          class: "preview-list",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (previewHover.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (previewHover.value = false))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (id, i) => {
            return (_openBlock(), _createBlock(AspectRatio, {
              key: id,
              onClick: ($event: any) => (setIndex(i)),
              ratio: __props.ratio,
              class: _normalizeClass(["preview-item", {current: i === index.value}])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(Image, {
                    id: id,
                    class: "image"
                  }, null, 8, ["id"]),
                  (__props.enableReorder && i === index.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["reorder-controls", { hovered: previewHover.value }])
                      }, [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (reorderLeft(i)), ["stop"]),
                          class: _normalizeClass(["reorder-button reorder-button-left", { invisible: i === 0 }])
                        }, [
                          _createVNode(_component_FontAwesomeIcon, { icon: "exchange-alt" })
                        ], 10, _hoisted_6),
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (reorderRight(i)), ["stop"]),
                          class: _normalizeClass(["reorder-button reorder-button-right", { invisible: i === __props.images.length - 1 }])
                        }, [
                          _createVNode(_component_FontAwesomeIcon, { icon: "exchange-alt" })
                        ], 10, _hoisted_7)
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["onClick", "ratio", "class"]))
          }), 128))
        ], 544))
      : _createCommentVNode("", true)
  ]))
}
}

})